/**
 * Google Tag conversion tracking utility
 * 
 * Usage: Call this function on purchase button clicks
 * Example: onClick={() => gtagReportConversion('https://buy.stripe.com/xxx')}
 */

export function gtagReportConversion(url) {
  const callback = function () {
    if (typeof url !== 'undefined' && url) {
      window.location = url;
    }
  };

  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-17429367033/cMipCJW2j_8aEPmR_PZA',
      value: 0.1,
      currency: 'CNY',
      event_callback: callback
    });
  } else {
    // Fallback: redirect immediately if gtag is not available
    callback();
  }

  return false;
}
